import React, { useEffect } from 'react';
import { useCurrentSubscription } from 'src/store/subscription';
import { ClockIcon } from '@heroicons/react/outline';

export const TrialStatus: React.FC = () => {
  const { 
    isOnTrial, 
    daysLeftInTrial, 
    trialExpired, 
    isSubscribed, 
    isStarter, 
    isPro, 
    isEnterprise 
  } = useCurrentSubscription();

  // Check if user is on any paid plan (excluding trial users)
  const isOnPaidPlan = isSubscribed || isStarter || (isPro && !isOnTrial) || isEnterprise;

  // Don't show anything if user is on a paid plan or not on trial and trial hasn't expired
  if (isOnPaidPlan || (!isOnTrial && !trialExpired)) {
    return null;
  }

  if (trialExpired) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <ClockIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">Trial Expired</h3>
            <div className="mt-2 text-sm text-red-700">
              <p>
                Your free trial has expired. Upgrade to a paid plan to continue using all features.
              </p>
            </div>
            <div className="mt-4">
              <div className="-mx-2 -my-1.5 flex">
                <button
                  type="button"
                  className="bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
                  onClick={() => window.location.href = '/dashboard/settings/billing'}
                >
                  Upgrade Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <ClockIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-blue-800">Free Trial Active</h3>
          <div className="mt-2 text-sm text-blue-700">
            <p>
              {daysLeftInTrial > 0 
                ? `You have ${daysLeftInTrial} days left in your free trial.` 
                : 'Your free trial ends today.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialStatus; 